/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
const submenu = document.querySelectorAll("[data-submenu]");
const header = document.querySelector("header");

function removeActiveHeader() {
  if (document.querySelectorAll(".dropdown-toggle__menu.active")) {
    document
      .querySelectorAll(".dropdown-toggle__menu.active")
      .forEach((item) => {
        item.classList.remove("active");
      });

    document.querySelectorAll(".dropdown-toggle").forEach((item) => {
      item.classList.remove("dropdown-showed");
      document.body.style.overflowY = "";
    });

    header.classList.remove("menu-showing");
    $header.removeClass('menu-showing');
    $('.dropdown-toggle').removeClass('dropdown-showed');
    $('body').css('overflow-y', '');
  }
}

function headerScrollingHandle() {
  var $header = $("header");
  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 1;
  var navbarHeight = $header.outerHeight();

  if ($('.table-of-content').length) {
    $('.table-of-content').addClass('headerUp');
  }

  $(window).scroll(function (event) {
    didScroll = true;
  });

  let delay = 350;
  if (document.querySelector(".all-products .all-products-head")) delay = 0;
  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      removeActiveHeader();
      didScroll = false;
    }
  }, delay);
  function hasScrolled() {
    var st = $(window).scrollTop();
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $('.desk_header-inner-container').removeClass('headerUp').addClass('headerDown');
      $('.filter-mobile-block').removeClass('headerUp');
      $('.desk_delivery-page-nav').removeClass('headerUp');
      $('.product-single').removeClass('HeaderDown');

      if ($('.table-of-content').length) {
        $('.table-of-content').removeClass('headerUp').addClass('headerDown');
      }

      if (
        document.querySelectorAll(".compare-section__products-mobile").length >
        0
      ) {
        document
          .querySelectorAll(".compare-section__products-mobile")
          .forEach((item) => {
            item.classList.remove("nav-showed");
          });
      }
      //document.querySelector(".compare-section__products");

      document
        .querySelectorAll(".compare-section__products")
        .forEach((item) => {
          item.classList.remove("nav-showed");
        });
      //&&
      //document
      //.querySelector(".compare-section__products")
      //.classList.remove("nav-showed");
      document.querySelector(".standing-desks__content") &&
        document
          .querySelectorAll(".standing-desks__content")
          .forEach((item) => item.classList.remove("nav-showed"));
      document.querySelector(".anchor-menu-section") &&
        document
          .querySelector(".anchor-menu-section")
          .parentNode.classList.remove("anchor-showed");
    } else {
      // Scroll Up
      $('.desk_header-inner-container').removeClass('headerDown').addClass('headerUp');
      $('.filter-mobile-block').addClass('headerUp');
      $('.desk_delivery-page-nav').addClass('headerUp');
      $('.product-single').addClass('HeaderDown');

      if ($('.table-of-content').length) {
        $('.table-of-content').removeClass('headerDown').addClass('headerUp');
      }

      if (st + $(window).height() < $(document).height()) {
        if (
          document.querySelectorAll(".compare-section__products-mobile")
            .length > 0
        ) {
          document
            .querySelectorAll(".compare-section__products-mobile")
            .forEach((item) => {
              item.classList.add("nav-showed");
            });
        }

        document
          .querySelectorAll(".compare-section__products")
          .forEach((item) => {
            item.classList.add("nav-showed");
          });
        // document.querySelector(".compare-section__products") &&
        //   document
        //     .querySelector(".compare-section__products")
        //     .classList.add("nav-showed");
        document.querySelector(".standing-desks__content") &&
          document
            .querySelectorAll(".standing-desks__content")
            .forEach((item) => item.classList.add("nav-showed"));
        document.querySelector(".anchor-menu-section") &&
          document
            .querySelector(".anchor-menu-section")
            .parentNode.classList.add("anchor-showed");
      }
    }

    if ($header.hasClass("transparent-on-top")) {
      $header.toggleClass("dark-bg", st > $header.height());
    }

    lastScrollTop = st;
  }

  if ($header.hasClass("transparent-on-top")) {
    $header.toggleClass("dark-bg", $(window).scrollTop() > $header.height());
  }
}

function handleMobileDropdowns() {
  const $dropdowns = $("[data-mobile-dropdown]");
  const $overlays = $(".drop-down-overlay-mobile");
  const headerWrapper = document.querySelector(".header__wrapper");
  const mainMenu = document.querySelector(".main-menu");

  function hideAllDropdowns() {
    headerWrapper.classList.remove("menu-mobile");
    document
      .querySelector(".menu-subpage-mobile.menu-page-mobile--active")
      ?.classList.remove("menu-page-mobile--active");
    mainMenu?.classList.add("menu-page-mobile--active");
    $dropdowns.each((i, dropdown) => {
      const $dropdownMenu = $($(dropdown).attr("data-mobile-dropdown"));
      $(dropdown).removeClass("dropdown-showed");
      document.body.style.overflowY = "";
      $dropdownMenu.fadeOut(200).removeClass("showing");
      $(dropdown).closest("header").removeClass("menu-showing");
      $('[class*="kl-teaser-"]').css('opacity', '1');
    });

    document
      .querySelectorAll(".dropdown-toggle__menu.active")
      .forEach((menu) => {
        menu.classList.remove("active");
      });

    submenu.forEach((item) => {
      item.classList.remove("dropdown-showed");
      document.body.style.overflowY = "";
    });
  }

  if ($dropdowns.length) {
    $dropdowns.on("click", function () {
      const $dropdownMenu = $($(this).attr("data-mobile-dropdown"));
      const isShowing = $dropdownMenu.hasClass("showing");

      hideAllDropdowns();
      if (!isShowing) {
        requestAnimationFrame(() => {
          $(this).addClass("dropdown-showed");
          document.body.style.overflowY = "hidden";
          $dropdownMenu.fadeIn(600).addClass("showing");
          $(this).closest("header").addClass("menu-showing");
          $('[class*="kl-teaser-"]').css('opacity', '0');

        });
      }
    });

    $overlays.on("click", function (e) {
      const $trg = $(e.target);

      if ($trg.hasClass("drop-down-overlay-mobile")) {
        hideAllDropdowns();
      }
    });
  }
}


function handleDropdowns() {
  const $dropdownToggles = $('[data-dropdown]');
  const $desktopOverlays = $('.mega-menu-container').not('.mega-menu-container-mobile');
  const $headerRoot      = $dropdownToggles.closest('header').first();
  let hideTimer;

  function isElementHovered($element) {
    return $element && $element.length && $element.is(':hover');
  }

  function isAnyRelatedHovered($dropdownToggle) {
    const $dropdownMenu = $($dropdownToggle.attr('data-dropdown'));
    const hoveredOverlayContainsMenu = $desktopOverlays.toArray().some(function(overlayElement) {
      return $.contains(overlayElement, $dropdownMenu[0]) && $(overlayElement).is(':hover');
    });
    return (
      isElementHovered($dropdownToggle) ||
      isElementHovered($dropdownMenu) ||
      hoveredOverlayContainsMenu
    );
  }

  function closeAllDropdowns() {
    $dropdownToggles.removeClass('dropdown-showed');
    $('[data-dropdown-menu]').stop(true, true).fadeOut(200).removeClass('showing');
    $('.dropdown-toggle__menu.active').removeClass('active');
    $('body').css('overflow-y', '');
    $headerRoot.removeClass('menu-showing');
  }

  function updateMenuShowingState() {
    // Only consider showing state if header has nav-down
    const navDown = $headerRoot.hasClass('nav-down');
    const anyToggleOrOverlayHovered =
      navDown && (
        $dropdownToggles.toArray().some(function(toggleElement) {
          return isAnyRelatedHovered($(toggleElement));
        }) ||
        $desktopOverlays.toArray().some(function(overlayElement) {
          return $(overlayElement).is(':hover');
        })
      );

    $headerRoot.toggleClass('menu-showing', !!anyToggleOrOverlayHovered);

    // If nav-down is absent while something is open, force close
    if (!navDown) closeAllDropdowns();
  }

  function hideAllOtherDropdowns(currentDropdownElement) {
    $dropdownToggles.each(function(_, toggleElement){
      if (toggleElement !== currentDropdownElement) {
        const $otherToggle = $(toggleElement);
        const $otherMenu   = $($otherToggle.attr('data-dropdown'));
        $otherToggle.removeClass('dropdown-showed');
        $otherMenu.stop(true, true).fadeOut(200).removeClass('showing');
      }
    });
    updateMenuShowingState();
  }

  function showDropdown($dropdownToggle) {
    // SAFETY: open only if header has nav-down
    if (!$headerRoot.hasClass('nav-down')) return;

    $('.nav-item.dropdown-showed').removeClass('dropdown-showed');
    $('.dropdown-toggle__menu.active').removeClass('active');
    clearTimeout(hideTimer);

    const $dropdownMenu = $($dropdownToggle.attr('data-dropdown'));

    hideAllOtherDropdowns($dropdownToggle[0]);

    $dropdownToggle.addClass('dropdown-showed');
    $dropdownMenu.stop(true, true).fadeIn(200).addClass('showing');

    $('body').css('overflow-y', 'hidden');
    updateMenuShowingState();
  }

  function hideDropdown($dropdownToggle) {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function(){
      const $dropdownMenu = $($dropdownToggle.attr('data-dropdown'));
      if (!isAnyRelatedHovered($dropdownToggle)) {
        $dropdownToggle.removeClass('dropdown-showed');
        $dropdownMenu.stop(true, true).fadeOut(200).removeClass('showing');
        $('body').css('overflow-y', '');
        updateMenuShowingState();
      }
    }, 10);
  }

  if (!$dropdownToggles.length) return;

  // Hover on dropdown toggles — gated by nav-down
  $dropdownToggles.on('mouseenter', function() {
    showDropdown($(this));
  });

  // Always allow hide on leave
  $dropdownToggles.on('mouseleave', function() {
    hideDropdown($(this));
  });

  // Leaving the dropdown menu itself — always allow hide
  $('[data-dropdown-menu]').on('mouseleave', function() {
    const menuId = $(this).attr('id');
    const $relatedToggle = $dropdownToggles.filter('[data-dropdown="#' + menuId + '"]');
    hideDropdown($relatedToggle);
  });

  // Overlays hover tracking
  $desktopOverlays.on('mouseenter', function() {
    updateMenuShowingState();
  });

  $desktopOverlays.on('mouseleave', function(event) {
    event.stopPropagation();

    const anyToggleStillHovered = $dropdownToggles.toArray().some(function(toggleElement) {
      return $(toggleElement).is(':hover');
    });

    if (!anyToggleStillHovered) {
      $('.dropdown-toggle__menu.active').removeClass('active');
      $('[data-dropdown]').removeClass('dropdown-showed');
      $('body').css('overflow-y', '');
      $(this).closest('.drop-down-overlay').stop(true, true).fadeOut(200).removeClass('showing');
      setTimeout(function(){
        $('.header').removeClass('menu-showing');
      },50);
    }

    updateMenuShowingState();
  });

}

const $header = $('.header');
const $submenuItems = $('.dropdown-toggle');

function isHovered($el) {
  return $el.is(':hover');
}

function hideSubMenu($menuItem) {
  const $panel = $menuItem.find('.dropdown-toggle__menu');
  $panel.removeClass('active');
  if ($('.drop-down-overlay').hasClass('showing')){

  }
  else{
    $header.removeClass('menu-showing');
    $('.dropdown-toggle').removeClass('dropdown-showed');
    $('body').css('overflow-y', '');
  }
  
}

function showSubMenu($menuItem) {
  if (!$header.hasClass('nav-down')) return; // safety check

  const $panel = $menuItem.find('.dropdown-toggle__menu');
  $panel.addClass('active');
  $header.addClass('menu-showing');
  $menuItem.addClass('dropdown-showed');
  $('body').css('overflow-y', 'hidden');
}

$submenuItems.each(function () {
  const $menuItem = $(this);

  $menuItem.on('mouseenter', function () {
    const $dropdowns = $('[data-dropdown]');

    $dropdowns.each(function () {
      const $dropdown = $(this);
      const $dropdownMenu = $($dropdown.attr('data-dropdown'));

      if (!isHovered($dropdownMenu) && !$dropdown.is($menuItem)) {
        $dropdown.removeClass('dropdown-showed');
        $('body').css('overflow-y', '');
        $dropdownMenu.fadeOut(200).removeClass('showing');
        $dropdown.closest('header').removeClass('menu-showing');
      }
    });

    $('.dropdown-toggle').each(function () {
      const $item = $(this);
      if (!isHovered($item) && !$item.is($menuItem)) {
        $item.removeClass('dropdown-showed');
        $('body').css('overflow-y', '');
      }
    });

    setTimeout(function () {
      showSubMenu($menuItem);
    }, 10);
  });

  $menuItem.on('mouseleave', function () {
    setTimeout(function () {
      if (!isHovered($menuItem)) {
        hideSubMenu($menuItem);
      }
    }, 10);
  });
});


// submenu.forEach(menu => {
//   menu.addEventListener("click", e => {
//     let menuItem = e.currentTarget;
//     if (menuItem.classList.contains("dropdown-showed")) {
//       hideSubMenu(menuItem);
//     } else {
//       const $dropdowns = $("[data-dropdown]");
//       $dropdowns.each((i, dropdown) => {
//         const $dropdownMenu = $($(dropdown).attr("data-dropdown"));
//         $(dropdown).removeClass("dropdown-showed");
//         document.body.style.overflowY = '';
//         $dropdownMenu.fadeOut(200).removeClass("showing");
//         $(dropdown).closest("header").removeClass("menu-showing");
//       });

//       document.querySelectorAll(".dropdown-toggle").forEach(item => {
//         item.classList.remove("dropdown-showed");
//         document.body.style.overflowY = '';
//       });
//       showSubMenu(menuItem);
//     }
//   });
// });

function handleToggleScroll() {
  $(".toggle-scroll").on("click", function () {
    $("body").toggleClass("no-scroll");
  });
}

function handleToggleAccordions() {
  const $accordions = $(".accordion-toggle");

  if ($accordions.length) {
    $accordions.on("click", function () {
      $(this).toggleClass("active");

      // footer scroll logic
      const accordionContent = $(this).next(".accordion");

      if (
        $(this).hasClass("active") &&
        $(this).hasClass("footer__links-heading")
      ) {
        const rect = accordionContent[0].getBoundingClientRect();

        const isVisible =
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <=
            (window.innerWidth || document.documentElement.clientWidth);

        if (!isVisible) {
          accordionContent[0].scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      }
    });
  }
}

function handleMegaMenuLinks() {
  const $links = $(".mega-menu-links-list > a:not(.link-disabled)");

  if ($links.length) {
    $links.on("mouseenter", function () {
      $links.each((_, ln) => {
        $(ln).removeClass("active");
      });
      $(this).addClass("active");
    });
  }
}

function isElementInViewport(element) {
  var elementFits = window.innerHeight > element.offsetHeight;
  var threshold = elementFits ? 0.5 : 0.3;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio >= threshold) {
          element.classList.add("intersect");
        }
        element.setAttribute(
          "data-intersection-ratio",
          entry.intersectionRatio
        );
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold,
    }
  );

  observer.observe(element);
}

function intersectOnScroll() {
  const $animatedElems = $(".wrapper .shopify-section, .wait-intersection");

  $animatedElems.each(function (_, elem) {
    isElementInViewport(elem);
  });
}

function setScrollByDrag() {
  HTMLElement.prototype.setScrollXByDrag = function () {
    let scrollLeft;
    let isDown;
    let startX;

    this.style.cursor = "grab";

    this.addEventListener("mousedown", function (e) {
      isDown = true;
      this.style.cursor = "grabbing";
      startX = e.pageX - this.offsetLeft;
      scrollLeft = this.scrollLeft;
    });
    this.addEventListener("mouseup", function () {
      isDown = false;
      this.style.cursor = "grab";
    });
    this.addEventListener("mouseleave", function mouseLeave() {
      isDown = false;
      this.style.cursor = "grab";
    });
    this.addEventListener("mousemove", function mouseMove(e) {
      if (isDown) {
        e.preventDefault();

        const x = e.pageX - this.offsetLeft;
        const walkX = (x - startX) * 5;
        this.scrollLeft = scrollLeft - walkX;
      }
    });
  };
}

function handleMegamenuOuter() {
  const $navItems = $('.desk_header-nav__item.has-dropdown');
  const $megamenu = $('.desk_header-megamenu-outer');

  if (!$navItems.length || !$megamenu.length) return;

  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let hideTimer;
  /** @type {ReturnType<typeof $> | null} */
  let $activeItem = null;

  const $shadow = $('.dropdown-shadow');

  /**
   * @param {number} mouseX
   * @param {number} mouseY
   */
  function isInExtendedZone(mouseX, mouseY) {
    if (!$activeItem || !$activeItem.length) return false;
    const rect = $activeItem[0].getBoundingClientRect();
    return mouseX >= rect.left && mouseX <= rect.right &&
           mouseY >= rect.top  && mouseY <= rect.bottom + 50;
  }

  function showMegamenu() {
    clearTimeout(hideTimer);
    if (!$megamenu.is(':visible')) {
      $megamenu.stop(true, true).slideDown(300);
      $shadow.stop(true, true).fadeIn(300);
      window.lockScroll();
    }
  }

  function schedulehide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (!$navItems.is(':hover') && !$megamenu.is(':hover')) {
        $megamenu.stop(true, true).slideUp(300);
        $navItems.removeClass('is-active');
        $activeItem = null;
        // Keep the overlay if the help dropdown is taking over the hover.
        if (!$('.desk_header-nav__item.has-help-dropdown').is(':hover')) {
          $shadow.stop(true, true).fadeOut(300);
          window.unlockScroll();
        }
      }
    }, 80);
  }

  $(document).on('mousemove.megamenu', function (e) {
    if ($megamenu.is(':visible') && isInExtendedZone(e.clientX, e.clientY)) {
      clearTimeout(hideTimer);
      hideTimer = undefined;
    }
  });

  $navItems.on('mouseenter', function () {
    $navItems.removeClass('is-active');
    $(this).addClass('is-active');
    $activeItem = $(this);
    showMegamenu();
  });
  $navItems.on('mouseleave', schedulehide);
  $megamenu.on('mouseenter', showMegamenu);
  $megamenu.on('mouseleave', schedulehide);
}

function handleHelpDropdown() {
  const $items = $('.desk_header-nav__item.has-help-dropdown');
  const $shadow = $('.dropdown-shadow');

  if (!$items.length || !$shadow.length) return;

  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let hideTimer;

  function showShadow() {
    clearTimeout(hideTimer);
    if (!$shadow.is(':visible')) {
      $shadow.stop(true, true).fadeIn(300);
      window.lockScroll();
    }
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      const megamenuActive =
        $('.desk_header-nav__item.has-dropdown').is(':hover') ||
        $('.desk_header-megamenu-outer').is(':hover');
      if (!$items.is(':hover') && !megamenuActive) {
        $shadow.stop(true, true).fadeOut(300);
        window.unlockScroll();
      }
    }, 80);
  }

  $items.on('mouseenter', showShadow);
  $items.on('mouseleave', scheduleHide);

  // Match the megamenu behaviour: hovering an item dims the whole list and
  // keeps only the hovered item at full colour.
  $('.desk_header-help-dropdown__item').on('mouseover', function () {
    $(this).closest('.desk_header-help-dropdown__list').addClass('hovered');
  });
  $('.desk_header-help-dropdown__item').on('mouseleave', function () {
    $('.desk_header-help-dropdown__list').removeClass('hovered');
  });
}

function handleMegamenuImages() {
  const $items = $('.desk_mega-menu__sublist-item[data-image]');
  const $img   = $('.desk_header-megamenu-image--js');

  if (!$items.length || !$img.length) return;

  $img.css('transition', 'opacity 0.2s ease');

  // Preload all images so swaps are instant
  $items.each(function () {
    const src = $(this).data('image');
    if (src) new Image().src = src;
  });

  $items.on('mouseenter', function () {
    const src = $(this).data('image');
    if (!src || $img.attr('src').includes(src)) return;

    const preloaded = new Image();
    preloaded.src = src;
    preloaded.onload = function () {
      $img.css('opacity', '0');
      setTimeout(function () {
        $img.attr('src', src).css('opacity', '1');
      }, 200);
    };
  });
}

function handleCartUpdates() {
  const cartDrawer = $("#CartDrawer");

  $(document.body).on("ajaxCart.afterCartLoad", (e, cart) => {
    if (cart.items.length > 0) {
      cartDrawer.removeClass("empty-cart");
    } else {
      cartDrawer.addClass("empty-cart");
    }
  });
}

let scriptStarted = false;

function mainHandle() {
  scriptStarted = true;

  /*header: */
  headerScrollingHandle();
  handleDropdowns();
  handleMobileDropdowns();
  handleMegamenuOuter();
  handleHelpDropdown();
  handleToggleScroll();
  handleToggleAccordions();
  handleMegaMenuLinks();

  /** Scroll by drag */
  setScrollByDrag();

  /** animations: */
  intersectOnScroll();

  handleMegamenuImages();

  /** cart */
  handleCartUpdates();
}

// This script is deferred, so by the time it runs the DOM is already parsed
// (readyState "interactive"). Initialise immediately instead of waiting for
// readyState "complete" — which is effectively window.load (after every image,
// video and third-party script finishes) and was the main reason the
// sticky / hide-on-scroll header stayed dead for the first seconds of a page.
function startHeaderScripts() {
  if (scriptStarted) return;
  mainHandle();
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", startHeaderScripts);
} else {
  startHeaderScripts();
}

class VariantSwitcher extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", () => {
      this.classList.toggle("is-open");
    });

    this.index = this.getAttribute("data-index");

    this.selectors = {
      variantItem: this.querySelectorAll(".js-variant-switcher__item"),
      switcherTitle: this.querySelector(".js-variant-swithcer__title"),
    };

    this.selectors.variantItem.forEach((item) => {
      item.addEventListener("click", () => {
        this.selectors.switcherTitle.innerHTML = item.innerHTML;
        this.classList.add("activated");
        this.classList.remove("is-open");
      });
    });

    let iterationCount = 0;
    this.selectors.variantItem.forEach((item) => {
      if (iterationCount === 1) {
        return false;
      }

      if (!this.classList.contains("pdp-variant-switcher")) {
        this.selectors.switcherTitle.innerHTML = item.innerHTML;
      }
      item.classList.add("activated");
      item.classList.remove("is-open");

      iterationCount++;
    });

    this.handleWindowClick = this.handleWindowClick.bind(this);
  }

  connectedCallback() {
    window.addEventListener("click", this.handleWindowClick);
  }

  disconnectedCallback() {
    window.removeEventListener("click", this.handleWindowClick);
  }

  handleWindowClick(event) {
    if (
      !event.target.closest("variant-switcher") ||
      (event.target.closest("variant-switcher") &&
        event.target.closest("variant-switcher").getAttribute("data-index") !=
          this.index)
    ) {
      this.classList.remove("is-open");
    }
  }
}

customElements.define("variant-switcher", VariantSwitcher);

let productChoiceWrapper = document.querySelectorAll(
  ".product-choice__wrapper"
);

function checkTextBoxHeight() {
  productChoiceWrapper.forEach((item) => {
    let itemTextBox = item.querySelectorAll(".product-item__footer"),
      itemTextBoxHeight = 0;
    itemTextBox.forEach((itemBox) => {
      if (itemBox.offsetHeight > itemTextBoxHeight) {
        itemTextBoxHeight = itemBox.offsetHeight;
      }
    });
    itemTextBox.forEach((itemBox) => {
      itemBox.style.height = `${itemTextBoxHeight}px`;
    });
  });
}

checkTextBoxHeight();
window.addEventListener("resize", checkTextBoxHeight);

//SHOP ALL PAGE

const standingDesksContent = document.querySelectorAll(
  ".standing-desks__content--desktop"
);
const options = {
  root: null,
  rootMargin: "0px",
  threshold: 0.5,
};

function callbackFunction(entries) {
  entries.forEach((entry) => {
    const targetElement = entry.target;
    const percentageVisible =
      (entry.intersectionRect.height / targetElement.offsetHeight) * 100;
    let currentSectionIndex = Number(targetElement.getAttribute("data-index"));
    if (percentageVisible > 50) {
      standingDesksContent.forEach((item) => {
        item.classList.remove("inViewport");
      });
      standingDesksContent[currentSectionIndex].classList.add("inViewport");
    }
  });
}

const observerStandingDesks = new IntersectionObserver(
  callbackFunction,
  options
);
const shopifySections = document.querySelectorAll(
  ".standing-desks__products-row"
);
shopifySections.forEach((section) => {
  observerStandingDesks.observe(section);
});

if (window.innerWidth < 1200) {
  observerStandingDesks.disconnect();
}

$(document).ready(function(){
  
  function openMobileMenu(){
    $('.desk_mob-menu-main-drawer').removeClass('hidedMobMenuDrawer');
    $('#MobMenuDrawer-Overlay').addClass('active');
    window.lockScroll();
  }

  function closeMobileMenu(){
    $('.desk_mob-menu-main-drawer').addClass('hidedMobMenuDrawer');
    $('#MobMenuDrawer-Overlay').removeClass('active');
    $('.desk_mob-menu-subitems-childs_out').slideUp();
    $('.desk_mob-menu-subitem-cont').removeClass('grandchildVisible');
    $('.desk_mob-menu-subitem_box').addClass('hidedMenu');

    window.unlockScroll();
  }

  $('.desk_mob-drawer-footer-lang').click(function(){
    $('.desk_mob-menu-subitem_box[data-attr="changeLan"]').removeClass('hidedMenu');
  });
  
  $('.has-children .desk_mob-menu-item__link').click(function(){
    var menuDataAttr = $(this).attr('data-attr');
    $('.desk_mob-menu-subitem_box[data-attr="' + menuDataAttr + '"]').removeClass('hidedMenu');
  });

  $('.closeSubmenu').click(function(){
    setTimeout(function(){
      $('.desk_mob-menu-subitem-cont').removeClass('grandchildVisible');
      $('.desk_mob-menu-subitems-childs_out').slideUp();
    },500);

    $('.desk_mob-menu-subitem_box').addClass('hidedMenu');
    
  });

  $('.desk_header-control-btn').click(function(){
    if ($(this).hasClass('desk_header-control__mob-menu')){
      openMobileMenu();
    }
  });

  $('.desk_mob-drawer-close-btn, #MobMenuDrawer-Overlay').click(function(){
    closeMobileMenu();
  });

  $(document).on('keyup', function(evt){
    if (evt.key === 'Escape' && !$('.desk_mob-menu-main-drawer').hasClass('hidedMobMenuDrawer')) {
      closeMobileMenu();
    }
  });


  $('.desk_mob-menu-subitem-cont.hasChildItems .desk_mob-menu-item__sub-link').click(function(evt){
    evt.preventDefault();
    $(this).closest('.desk_mob-menu-subitem-cont.hasChildItems').toggleClass('grandchildVisible');
    $(this).closest('.desk_mob-menu-subitem-cont.hasChildItems').find('.desk_mob-menu-subitems-childs_out').slideToggle();
  });

  $('.desk_mega-menu__sublist-item').mouseover(function(){
    $(this).closest('.desk_mega-menu__sublist').addClass('hovered');
  });

  $('.desk_mega-menu__sublist-item').mouseleave(function(){
    $('.desk_mega-menu__sublist').removeClass('hovered');
  });

});